﻿import IconHelper from '@bazooka_se/lf-icons';

const Link = ({ href, linkText }) => {

    return (
        <a className="pension-wizard-block__question__card__question__download-link"
            href={href}
        target="_blank">
            <span
                className="pension-wizard-block__question__card__question__download-link__icon"
                dangerouslySetInnerHTML={{ __html: IconHelper('download').outerHTML }}>
            </span>
        {linkText}
        </a>
      )
}

export default Link;

